import { render, staticRenderFns } from "./OvertimeAttachmentWasAdded.vue?vue&type=template&id=3ab5f036"
import script from "./OvertimeAttachmentWasAdded.vue?vue&type=script&lang=js"
export * from "./OvertimeAttachmentWasAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports